<!--
  @component

  The icon component is used to display any icon from [@otto-ec/icons](https:/*                               */

  ```html
  <oc-icon-v1 type="360-degree" size="100"></oc-banner-v1>
  ```
-->
<svelte:options
  customElement={{
    tag: "oc-icon-v1",
    props: {
      color: { type: "String" },
      size: { type: "String", reflect: true },
      type: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { IconType } from "@otto-ec/icons";

  /**
 *
 *
 */
  export let type: IconType;
  /**
 *
 *
 */
  export let size: "50" | "100" | "200" = "100";
  /**
 *
 *
 */
  export let color: string | undefined = undefined;

  $: iconIdentifier = `pl_icon_${type}${size === "50" ? "50" : ""}`;
  $: href = `/assets-static/icons/${iconIdentifier}.svg#${iconIdentifier}`;
  $: style = color && `fill: ${color}`;
</script>

<svg {style}>
  <use {href} />
</svg>

<style lang="scss">
  @use "./IconV1.config" as config;

  :host {
    @include config.oc-icon;
  }

  :host([size="50"]) {
    @include config.oc-icon-size-50;
  }

  :host([size="100"]) {
    @include config.oc-icon-size-100;
  }

  :host([size="200"]) {
    @include config.oc-icon-size-200;
  }

  svg {
    height: 100%;
    width: 100%;
  }
</style>
